import {Trans} from '@lingui/macro'
import styled from 'styled-components'

import type {ButtonProps} from '@pleo-io/telescope'
import {Button, Inline, Stack, Text, tokens} from '@pleo-io/telescope'

import {Accordion} from '~/generic-ui/accordion'

import {usePleoLinks} from '../../adoption-centre-link-helpers'
import {trackHelpWidgetLinkClick} from '../../tracking'
import {StyledAccordionItem, StyledHeader, Title} from '../components'

const MoreItemLink = styled(Button).attrs<ButtonProps, ButtonProps>({
    variant: 'link-secondary',
    target: '_blank',
    rel: 'noopener noreferrer',
})``

const MoreItem = () => {
    const {getBlogLink, getCommercialLink} = usePleoLinks()

    return (
        <StyledAccordionItem
            value={MoreItem.accordionItemId}
            data-testid="adoption-centre-more-item-accordion"
        >
            <StyledHeader>
                <Title>
                    <Trans>More</Trans>
                </Title>
                <Accordion.Chevron />
            </StyledHeader>
            <Accordion.Content>
                <Stack space={12}>
                    <MoreItemLink
                        href={getBlogLink('/category/pleo-updates')}
                        onClick={() => trackHelpWidgetLinkClick('updates')}
                        data-testid="adoption-centre-new-link"
                    >
                        <Text color="shade800">
                            <Inline alignY="center" space={10}>
                                <span role="img" aria-hidden="true">
                                    🎁
                                </span>
                                <Trans>What's new</Trans>
                            </Inline>
                        </Text>
                    </MoreItemLink>
                    <MoreItemLink
                        href={getCommercialLink('/perks-internal')}
                        onClick={() => trackHelpWidgetLinkClick('perks')}
                        data-testid="adoption-centre-perks-link"
                    >
                        <Text color="shade800">
                            <Inline alignY="center" space={10}>
                                <span role="img" aria-hidden="true">
                                    🔥
                                </span>
                                <Trans>Perks</Trans>
                            </Inline>
                        </Text>
                    </MoreItemLink>
                    <MoreItemLink
                        css={{marginBottom: tokens.spacing12}}
                        href={getCommercialLink('/referral')}
                        onClick={() => trackHelpWidgetLinkClick('referral')}
                        data-testid="adoption-centre-refer-link"
                    >
                        <Text color="shade800">
                            <Inline alignY="center" space={10}>
                                <span role="img" aria-hidden="true">
                                    🤝
                                </span>
                                <Trans>Refer a friend</Trans>
                            </Inline>
                        </Text>
                    </MoreItemLink>
                    <MoreItemLink
                        href={getCommercialLink('/legal')}
                        onClick={() => trackHelpWidgetLinkClick('terms')}
                        data-testid="adoption-centre-terms-link"
                    >
                        <Text variant="small-subtle" color="shade700">
                            <Trans>Terms</Trans>
                        </Text>
                    </MoreItemLink>
                    <MoreItemLink
                        href="https://status.pleo.io"
                        onClick={() => trackHelpWidgetLinkClick('status')}
                        data-testid="adoption-centre-status-link"
                    >
                        <Text variant="small-subtle" color="shade700">
                            <Trans>Service status</Trans>
                        </Text>
                    </MoreItemLink>
                </Stack>
            </Accordion.Content>
        </StyledAccordionItem>
    )
}

// Used to identify currently open accordion item
MoreItem.accordionItemId = 'help-item'

export default MoreItem
